// extracted by mini-css-extract-plugin
module.exports = {"seo-nav":"seo-links_seo-nav__TSk32"};